declare const jobData: any; // from localized JSON_small file
import * as JobTypes from "../types/jobData";
import { JobOverviewPage } from "./jobOverviewPage";

export class JobSorterUI {
  private jobSorter: JobSorter;
  private sortSelect: HTMLSelectElement;
  private jobOverviewPage: JobOverviewPage;

  constructor(jobSorter: JobSorter, jobOverviewPage: JobOverviewPage) {
    this.jobSorter = jobSorter;
    this.jobOverviewPage = jobOverviewPage;
    this.sortSelect = document.querySelector("#job-sorting") as HTMLSelectElement;

    if (!this.sortSelect) {
      console.error("Sort Select not found");
      return;
    }

    this.setEvents();
  }

  private setEvents() {
    this.sortSelect.addEventListener("change", () => {
      const selectedValue = this.sortSelect.value;

      // Handover selected value to JobSorter and perform sort
      this.jobSorter.SortValue = selectedValue;
      this.jobSorter.performSort(() => this.jobOverviewPage.getFilteredJobs);
    });
  }
}

export class JobSorter {
  private sortValue: string = "alphabetical";
  private sortCallback: (jobs: JobTypes.jobData[]) => void = () => {};

  constructor() {
    this.setEvents();
  }

  public set SortValue(value: string) {
    this.sortValue = value;
  }

  public onSortChange(callback: (jobs: JobTypes.jobData[]) => void) {
    this.sortCallback = callback;
  }

  public performSort(getJobs: () => JobTypes.jobData[]) {
    const jobs = getJobs();
    console.log("Sortiere Jobsansicht...");
    console.log("Aktuelle Jobs zum sortieren:", jobs);

    // Sort Jobs
    const sortedJobs = this.sortJobs(jobs);
    // this.logSortedJobs(sortedJobs, this.sortValue);
    // Call the callback with the sorted jobs
    this.sortCallback(sortedJobs);
  }

  public performSortReturn(jobs: JobTypes.jobData[]): JobTypes.jobData[] {
    const sortedJobs = this.sortJobs(jobs);
    return sortedJobs;
  }

  // DEBUGGING FUNCTION
  private logSortedJobs(sortedJobs: JobTypes.jobData[], sortValue: string) {
    console.log(`✅ Jobs wurden nach "${sortValue}" sortiert.`);

    if (sortedJobs.length === 0) {
      console.log("⚠️ Keine Jobs vorhanden.");
      return;
    }

    console.log("📌 Erste 3 Jobs nach Sortierung:");

    sortedJobs.slice(0, 3).forEach((job, index) => {
      console.log(`🔹 Job ${index + 1}:`);

      switch (sortValue) {
        case "alphabetical":
          console.log(`📄 Title: ${job.pageTitle}`);
          break;

        case "newest":
        case "oldest":
          console.log(`📅 Created Date: ${job.jobOpening.createdDate}`);
          break;

        case "location":
          const city = job.jobOpening.locations?.[0]?.address?.city || "Unbekannt";
          console.log(`📍 Stadt: ${city}`);
          break;

        default:
          console.log("⚠️ Keine bekannte Sortieroption.");
      }
    });
  }

  private sortJobs(jobs: JobTypes.jobData[]): JobTypes.jobData[] {
    let sorted = jobs;
    return sorted.sort((a, b) => {
      switch (this.sortValue) {
        case "alphabetical":
          return a.pageTitle.localeCompare(b.pageTitle);

        case "newest":
          return new Date(b.jobOpening.createdDate).getTime() - new Date(a.jobOpening.createdDate).getTime();

        case "oldest":
          return new Date(a.jobOpening.createdDate).getTime() - new Date(b.jobOpening.createdDate).getTime();

        case "location":
          // const cityA = a.jobOpening.locations?.[0]?.address?.city || "";
          // const cityB = b.jobOpening.locations?.[0]?.address?.city || "";
          // return cityA.localeCompare(cityB);
          const cityA = a.jobOpening.locations?.[0]?.address?.city || "zzzzzz";
          const cityB = b.jobOpening.locations?.[0]?.address?.city || "zzzzzz";
          return cityA.localeCompare(cityB, undefined, { sensitivity: "base" });

        default:
          return 0; // Keine Sortierung
      }
    });
  }

  private setEvents() {
    /// #job-sorting
    const sortSelect = document.querySelector("#job-sorting") as HTMLSelectElement;
    if (!sortSelect) {
      console.error("Sort Select not found");
      return;
    }

    sortSelect.addEventListener("change", (event) => {
      const selectedValue = (event.target as HTMLSelectElement).value;
      console.log("Selected Sort Value:", selectedValue);
    });
    // TODO:  onChange Event on Select Field
  }
}
